import { ListItem } from '../../../../../interfaces/order'
import moment from 'moment'
import AppSelect from '../../../../../components/atoms/AppSelect/AppSelect'
import { orderChangeStates, orderStates, orderStatesSelect } from '../../../../../utils/constants'
import { OperationModeBadge } from '../../../../../core/presentation/components/molecules/OperationModeBadge/OperationModeBadge'
import { OPERATION_MODE_CODES } from '../../../../../core/domain/operationModeConstants'
import OrderSummaryPill from 'orders/presentation/components/molecules/OrderSummaryPill/OrderSummaryPill'

const OrderItem = ({
    children,
    description,
    code,
    created_at,
    state,
    onChange,
    warehouse_name,
    operationMode,
    packages,
    containers,
    chutes,
    template,
}: ListItem) => {
    const getLeftBorderColor = () => {
        if (state === orderStatesSelect.IN_PROCESS.value && operationMode) {
            if (operationMode.code === OPERATION_MODE_CODES.SORTER) {
                return 'border-l-[#0084FF] border-l-4'
            }
            if (operationMode.code === OPERATION_MODE_CODES.CLASSIFICATION) {
                return 'border-l-[#FF8802] border-l-4'
            }
        }
        return ''
    }

    return (
        <div className={`border border-[#CBD5E1] ${getLeftBorderColor()} hover:border-[#1F2531] transition-colors duration-200 flex justify-between items-center px-[20px] py-[16px] bg-white rounded-xl`}>
            <div className="text-left flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                    <h2 className="font-medium text-lg leading-[1.2] text-[#141A1F]">{code || description}</h2>

                    {operationMode && (
                        <OperationModeBadge operationMode={operationMode} />
                    )}

                    <OrderSummaryPill
                        packages={packages}
                        containers={containers}
                        chutes={chutes}
                        operationModeCode={operationMode?.code}
                    />
                </div>

                <div className="flex items-center mt-2 gap-3 text-sm text-gray-500">
                    <span>{moment(created_at).format('DD MMM YYYY HH:mm')}</span>

                    {warehouse_name && (
                        <>
                            <div className="w-px h-4 bg-gray-300" />
                            <span>Warehouse: {warehouse_name}</span>
                        </>
                    )}

                    <div className="w-px h-4 bg-gray-300" />
                    <span>Plantilla: <span className="text-gray-600">{template ?? ''}</span></span>
                </div>
            </div>

            <div className="flex items-center gap-2">
                {state && state !== orderStatesSelect.IN_PROCESS.value ? (
                    <span className="text-base font-normal text-[#94A3B8] whitespace-nowrap">
                        {orderStatesSelect[state]?.label ?? state}
                    </span>
                ) : (
                    <div className="w-[152px]">
                        <AppSelect
                            value={state}
                            options={orderChangeStates}
                            onChange={(state) => onChange(state.target.value as orderStates)}
                        />
                    </div>
                )}
                {children}
            </div>
        </div>
    )
}

export default OrderItem
